export type FolderTemplateSlug = 'conseil' | 'contentieux';
export type FolderTemplateChoice = 'none' | FolderTemplateSlug;

export const FOLDER_TEMPLATES: Record<FolderTemplateSlug, readonly string[]> = {
  conseil: [
    'Débours',
    'Documentation juridique',
    'Documents client',
    'Documents signés',
    'Factures',
    'Formalités',
    'Notes',
    'Proposition de mission',
    'Recherches',
  ],
  contentieux: [
    'Correspondances',
    'Divers',
    'Factures',
    'Nos pièces',
    'Pièces adverses',
    'Procédure',
    'Proposition de mission',
    'Recherches',
    'RPVA',
  ],
};

export const FOLDER_TEMPLATE_CHOICES: readonly {
  slug: FolderTemplateChoice;
  label: string;
}[] = [
  { slug: 'none', label: 'Vide' },
  { slug: 'conseil', label: 'Conseil' },
  { slug: 'contentieux', label: 'Contentieux' },
];

export function folderNamesForTemplate(choice: FolderTemplateChoice): readonly string[] {
  if (choice === 'none') return [];
  return FOLDER_TEMPLATES[choice];
}

export function canApplyFolderTemplate(existingFolderCount: number): boolean {
  return existingFolderCount === 0;
}

export function shouldApplyFolderTemplate(
  choice: string,
  existingFolderCount: number,
): boolean {
  return choice !== 'none' && canApplyFolderTemplate(existingFolderCount);
}
